// src/components/store/sections/faqs/FaqV74SteppernumberedTealLagoon.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV74SteppernumberedTealLagoon(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={74}
      archKey="stepper_numbered"
      archLabel="Numbered Stepper FAQ"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
